import { FC } from 'react'
import { useWorkdayEmployeeUpdateFailures } from '../hooks/useWorkdayEmployeeUpdateFailures'
import { NewHeader } from 'components/page-header/NewHeader'
import { Spinner } from 'components/loaders'
import { Table } from '../components/workday-employee-update-failures/Table'

export const WorkdayEmployeeUpdateFailures: FC = () => {
  const { data: failures } = useWorkdayEmployeeUpdateFailures()

  return (
    <div className="flex flex-col flex-grow">
      <NewHeader title="Workday Employee Update Failures" />

      {failures ? <Table failures={failures} /> : <Spinner />}
    </div>
  )
}
